/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['Ꭲ', 'ᏌᎾᎴ', 'ᏒᎯᏱᎢᏗᏢ'],
    ['ᎢᎦ', 'ᏌᎾᎴ', 'ᏒᎯᏱᎢᏗᏢ'],
  ],
  [
    ['ᎢᎦ', 'ᏌᎾᎴ', 'ᏒᎯᏱᎢᏗᏢ'],
    ,
  ],
  ['12:00', ['00:00', '12:00'], ['12:00', '24:00']]
];
